import React from 'react'
import "./authMainTitle.scss"

interface AuthMainTitleProps {
  className?: string;
  mainTitleText?: string;
}

const AuthMainTitle: React.FC<AuthMainTitleProps> = ({ className, mainTitleText }) => {
  return (
    <div className={`auth-main-title ${className}`}>
      <h3 className='auth-text'>{mainTitleText}</h3>
    </div>
  )
}

export default AuthMainTitle